import { useState, useRef } from "react";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { storage } from "../firebase";
import { C, Topbar, Label, isValidUKPhone } from "../components/shared";

export default function CustomerForm({ onSubmit, onBack }) {
  const [step, setStep] = useState(1);
  const [data, setData] = useState({ workType:"", budget:"", timeline:"", dropoff:"", quotedElsewhere:"", vehicle:"", damage:"", callTime:"", notes:"", name:"", phone:"", whatsapp:"", email:"" });
  const [photos, setPhotos] = useState([]); // preview URLs
  const [photoFiles, setPhotoFiles] = useState([]); // actual files
  const [photoErr, setPhotoErr] = useState("");
  const [uploading, setUploading] = useState(false);
  const [done, setDone] = useState(false);
  const fileRef = useRef();
  const total = 7;

  const set = (k,v) => setData(d=>({...d,[k]:v}));
  const next = () => { setStep(s=>Math.min(s+1,total)); window.scrollTo({top:0}); };
  const back = () => { if(step===1){onBack();return;} setStep(s=>Math.max(s-1,1)); window.scrollTo({top:0}); };
  const pct = Math.round((step/total)*100);

  const handlePhotos = (files) => {
    const newFiles = Array.from(files);
    setPhotoFiles(prev => {
      const combined = [...prev, ...newFiles].slice(0, 6);
      // Generate previews for all combined files
      Promise.all(combined.map(f => new Promise(res => {
        const r = new FileReader();
        r.onload = e => res(e.target.result);
        r.readAsDataURL(f);
      }))).then(setPhotos);
      return combined;
    });
  };

  const submit = async () => {
    setUploading(true);
    try {
      const photoUrls = [];
      for (const file of photoFiles) {
        const photoRef = ref(storage, `leads/${Date.now()}_${Math.random()}_${file.name}`);
        await uploadBytes(photoRef, file);
        const url = await getDownloadURL(photoRef);
        photoUrls.push(url);
      }
      await onSubmit({
        ...data,
        photoUrls,
        photoCount: photoUrls.length,
        source: "Website Form",
        tier: "qualified",
        area: "UK",
        buyers: [],
        status: "new",
      });
      setDone(true);
      window.scrollTo({top:0});
    } catch (e) {
      console.error(e);
      alert("Something went wrong uploading your photos. Please check your connection and try again.");
    }
    setUploading(false);
  };

  const OptBtn = ({ field, value }) => {
    const sel = data[field]===value;
    return (
      <div onClick={()=>set(field,value)} style={{ background: sel?"#1a0a06":C.card, border:`1.5px solid ${sel?"#E8341A":C.border}`, borderRadius:13, padding:"14px 16px", cursor:"pointer", fontSize:14, color: sel?C.text:"#CCCCCC", display:"flex", alignItems:"center", gap:12, fontWeight: sel?600:400 }}>
        <div style={{ width:20, height:20, borderRadius:"50%", border:`2px solid ${sel?"#E8341A":C.subtle}`, flexShrink:0, display:"flex", alignItems:"center", justifyContent:"center", background: sel?"#E8341A":"transparent" }}>
          {sel && <span style={{ fontSize:11, color:"#fff", fontWeight:800 }}>✓</span>}
        </div>
        {value}
      </div>
    );
  };

  const backBtn = <button onClick={back} style={{ background:"rgba(255,255,255,0.06)", border:`1px solid ${C.border}`, color:C.muted, cursor:"pointer", fontFamily:"inherit", fontSize:12, fontWeight:600, padding:"6px 12px", borderRadius:8, display:"flex", alignItems:"center", gap:5 }}>← Back</button>;

  if (done) return (
    <div style={{ minHeight:"100vh", background:C.dark, color:C.text, fontFamily:"'DM Sans',sans-serif" }}>
      <div style={{ background:"#111", borderBottom:`1px solid ${C.border}`, padding:"14px 20px", cursor:"pointer", display:"flex", alignItems:"center" }} onClick={onBack}>
        <div style={{ fontSize:16, fontWeight:900 }}><span style={{ color:"#E8341A" }}>Quote</span><span style={{ color:C.text }}>MyBodywork</span></div>
      </div>
      <div style={{ padding:"50px 24px", textAlign:"center", maxWidth:480, margin:"0 auto" }}>
        <div style={{ width:72, height:72, background:"rgba(22,163,74,0.15)", border:`2px solid ${C.green}`, borderRadius:"50%", display:"flex", alignItems:"center", justifyContent:"center", fontSize:32, margin:"0 auto 24px" }}>✓</div>
        <h2 style={{ fontSize:30, fontWeight:900, marginBottom:12 }}>You're all set!</h2>
        <p style={{ color:"#999", fontSize:15, lineHeight:1.75, maxWidth:300, margin:"0 auto 32px" }}>Your details have been sent to verified bodyshops in your area. Expect a call or WhatsApp within 24–48 hours.</p>
        <div style={{ background:C.card, border:`1px solid ${C.border}`, borderRadius:16, padding:22, textAlign:"left", marginBottom:28 }}>
          <div style={{ fontSize:11, fontWeight:700, color:C.muted, textTransform:"uppercase", letterSpacing:"0.7px", marginBottom:16 }}>What happens next</div>
          {["Verified local bodyshops review your job details and photos","They call or WhatsApp you directly to discuss and give a quote","You pick the best quote and get your car sorted"].map((t,i)=>(
            <div key={i} style={{ display:"flex", gap:14, marginBottom:14, fontSize:14, lineHeight:1.6, alignItems:"flex-start", color:"#CCCCCC" }}>
              <div style={{ width:26, height:26, borderRadius:"50%", background:"#E8341A", color:"#fff", fontSize:12, fontWeight:800, display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}>{i+1}</div>
              <div>{t}</div>
            </div>
          ))}
        </div>
        <button onClick={onBack} style={{ width:"100%", background:"#E8341A", color:"#fff", border:"none", borderRadius:14, padding:"15px", fontSize:15, fontWeight:800, cursor:"pointer", fontFamily:"inherit", marginBottom:10 }}>
          Back to homepage
        </button>
        <button onClick={()=>{ setDone(false); setStep(1); setData({ workType:"", budget:"", timeline:"", dropoff:"", quotedElsewhere:"", vehicle:"", damage:"", callTime:"", notes:"", name:"", phone:"", whatsapp:"", email:"" }); setPhotos([]); setPhotoFiles([]); window.scrollTo({top:0}); }}
          style={{ width:"100%", background:"transparent", color:C.muted, border:`1px solid ${C.border}`, borderRadius:14, padding:"13px", fontSize:14, fontWeight:600, cursor:"pointer", fontFamily:"inherit" }}>
          Submit another quote request
        </button>
      </div>
    </div>
  );

  return (
    <div style={{ minHeight:"100vh", background:C.dark, color:C.text, fontFamily:"'DM Sans',sans-serif" }}>
      <Topbar left={backBtn} right={null} onLogoClick={onBack} />
      <div style={{ padding:"16px 20px 0", maxWidth:540, margin:"0 auto" }}>
        <div style={{ display:"flex", justifyContent:"space-between", fontSize:11, color:C.muted, marginBottom:8, fontWeight:600 }}>
          <span>Step {step} of {total}</span><span>{pct}%</span>
        </div>
        <div style={{ height:3, background:C.border, borderRadius:3, overflow:"hidden" }}>
          <div style={{ height:"100%", width:`${pct}%`, background:"#E8341A", borderRadius:3, transition:"width 0.4s ease" }} />
        </div>
        <div style={{ display:"flex", justifyContent:"center", gap:5, paddingTop:12 }}>
          {Array.from({length:total}).map((_,i)=>(
            <div key={i} style={{ height:6, borderRadius: i+1===step?3:"50%", width: i+1===step?20:6, background: i+1<=step?"#E8341A":C.border, opacity: i+1<step?0.45:1 }} />
          ))}
        </div>
      </div>

      <div style={{ maxWidth:540, margin:"0 auto", padding:"24px 20px 48px" }}>

        {step===1 && (
          <div>
            <h2 style={{ fontSize:26, fontWeight:900, marginBottom:8 }}>What type of work do you need?</h2>
            <p style={{ fontSize:14, color:"#999", marginBottom:24, lineHeight:1.6 }}>Select the option that best describes your job.</p>
            <div style={{ display:"flex", flexDirection:"column", gap:10 }}>
              {["Bodywork & Paint","Partial Restoration / Specific Repair","Full Restoration"].map(v=><OptBtn key={v} field="workType" value={v} />)}
            </div>
            <button onClick={()=>{ if(!data.workType){alert("Please select the type of work needed.");return;} next(); }} style={redBtn}>Continue →</button>
          </div>
        )}

        {step===2 && (
          <div>
            <h2 style={{ fontSize:26, fontWeight:900, marginBottom:8 }}>What's your budget?</h2>
            <p style={{ fontSize:14, color:"#999", marginBottom:24, lineHeight:1.6 }}>Helps bodyshops send you relevant, accurate quotes.</p>
            <div style={{ display:"flex", flexDirection:"column", gap:10 }}>
              {["Under £500","£500 – £1,000","£1,000 – £5,000","£5,000 – £10,000"].map(v=><OptBtn key={v} field="budget" value={v} />)}
            </div>
            <button onClick={()=>{ if(!data.budget){alert("Please select your budget.");return;} next(); }} style={redBtn}>Continue →</button>
          </div>
        )}

        {step===3 && (
          <div>
            <h2 style={{ fontSize:26, fontWeight:900, marginBottom:8 }}>When are you looking to get this done?</h2>
            <p style={{ fontSize:14, color:"#999", marginBottom:24, lineHeight:1.6 }}>Be honest — shops appreciate knowing your urgency.</p>
            <div style={{ display:"flex", flexDirection:"column", gap:10 }}>
              {["As soon as possible","Within the next 2 weeks","Just getting a quote for now"].map(v=><OptBtn key={v} field="timeline" value={v} />)}
            </div>
            <div style={{ marginTop:22 }}><Label>Are you ready to book a vehicle drop-off?</Label>
              <div style={{ display:"flex", flexDirection:"column", gap:10 }}>
                {["Yes, ready to move forward","Getting a few quotes first","Not yet, just exploring"].map(v=><OptBtn key={v} field="dropoff" value={v} />)}
              </div>
            </div>
            <div style={{ marginTop:22 }}><Label>Have you been quoted for this job elsewhere?</Label>
              <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:10 }}>
                {["Yes","No"].map(v=><OptBtn key={v} field="quotedElsewhere" value={v} />)}
              </div>
            </div>
            <button onClick={()=>{
              if(!data.timeline){alert("Please select when you want the job done.");return;}
              if(!data.dropoff){alert("Please answer: ready to book a drop-off?");return;}
              if(!data.quotedElsewhere){alert("Please answer: quoted elsewhere?");return;}
              next();
            }} style={redBtn}>Continue →</button>
          </div>
        )}

        {step===4 && (
          <div>
            <h2 style={{ fontSize:26, fontWeight:900, marginBottom:8 }}>Tell us about your vehicle</h2>
            <p style={{ fontSize:14, color:"#999", marginBottom:24, lineHeight:1.6 }}>The more detail, the more accurate the quotes.</p>
            <Label>What type of vehicle do you have?</Label>
            <input value={data.vehicle} onChange={e=>set("vehicle",e.target.value)} placeholder="e.g. Ford Focus 2019, VW T5, Audi A3..." style={inputStyle} />
            <div style={{ marginTop:18 }}><Label>Please describe the damage</Label>
              <textarea value={data.damage} onChange={e=>set("damage",e.target.value)} placeholder="e.g. Dent on rear bumper, scratch on driver door, rust on rear arches..." rows={4} style={{ ...inputStyle, resize:"none", lineHeight:1.6 }} />
            </div>
            <button onClick={()=>{
              if(!data.vehicle.trim()){alert("Please enter your vehicle type.");return;}
              if(!data.damage.trim()){alert("Please describe the damage.");return;}
              next();
            }} style={redBtn}>Continue →</button>
          </div>
        )}

        {step===5 && (
          <div>
            <h2 style={{ fontSize:26, fontWeight:900, marginBottom:8 }}>Add photos of the damage</h2>
            <p style={{ fontSize:14, color:"#999", marginBottom:24, lineHeight:1.6 }}>You need at least 3 clear photos. Good lighting = better quotes.</p>
            <div onClick={()=>fileRef.current?.click()} style={{ border:`2px dashed ${photos.length>=3?C.greenLight:C.border}`, borderRadius:16, padding:"32px 20px", textAlign:"center", cursor:"pointer", background: photos.length>=3?"rgba(22,163,74,0.05)":C.card }}>
              <div style={{ fontSize:40, marginBottom:12 }}>📸</div>
              <p style={{ fontSize:14, color:"#999", lineHeight:1.6 }}><strong style={{ color:C.text }}>Tap to add photos</strong><br />Minimum 3 · Maximum 6 · JPG or PNG</p>
            </div>
            <input ref={fileRef} type="file" accept="image/*" multiple style={{ display:"none" }} onChange={e=>handlePhotos(e.target.files)} />
            {photos.length>0 && (
              <div style={{ marginTop:14 }}>
                <div style={{ fontSize:13, textAlign:"center", color: photos.length>=3?C.greenLight:"#f97316", marginBottom:12, fontWeight:600 }}>
                  {photos.length>=3 ? `✓ ${photos.length} photos ready` : `${photos.length} photo${photos.length>1?"s":""} — need ${3-photos.length} more`}
                </div>
                <div style={{ display:"grid", gridTemplateColumns:"repeat(3,1fr)", gap:8 }}>
                  {photos.map((src,i)=>(<div key={i} style={{ aspectRatio:1, borderRadius:12, overflow:"hidden", border:`1px solid ${C.border}` }}><img src={src} alt="" style={{ width:"100%", height:"100%", objectFit:"cover" }} /></div>))}
                </div>
              </div>
            )}
            {photoErr && <div style={{ marginTop:12, background:"#2d1010", border:"1px solid #6b2020", borderRadius:10, padding:"12px 16px", fontSize:13, color:"#f87171" }}>{photoErr}</div>}
            <button onClick={()=>{ if(photos.length<3){setPhotoErr(`Please add at least 3 photos. You've added ${photos.length} so far.`);return;} setPhotoErr("");next(); }} style={redBtn}>Continue →</button>
          </div>
        )}

        {step===6 && (
          <div>
            <h2 style={{ fontSize:26, fontWeight:900, marginBottom:8 }}>How should bodyshops reach you?</h2>
            <p style={{ fontSize:14, color:"#999", marginBottom:24, lineHeight:1.6 }}>Your details stay private until a verified shop purchases your lead.</p>
            <Label>Full name</Label>
            <input value={data.name} onChange={e=>set("name",e.target.value)} placeholder="Your full name" style={inputStyle} />
            <div style={{ marginTop:16 }}>
              <Label>Best phone number</Label>
              <input type="tel" value={data.phone} onChange={e=>set("phone",e.target.value)} placeholder="07700 900000"
                style={{ ...inputStyle, borderColor: data.phone&&!isValidUKPhone(data.phone)?"#ef4444":C.border }} />
              {data.phone&&!isValidUKPhone(data.phone) && <div style={{ fontSize:12, color:"#f87171", marginTop:6 }}>⚠ Please enter a valid UK mobile number (e.g. 07700 900000)</div>}
            </div>
            <div style={{ marginTop:16 }}>
              <Label>WhatsApp number</Label>
              <input type="tel" value={data.whatsapp} onChange={e=>set("whatsapp",e.target.value)} placeholder="e.g. 07700 900000"
                style={{ ...inputStyle, borderColor: data.whatsapp&&!isValidUKPhone(data.whatsapp)?"#ef4444":inputStyle.borderColor }} />
              {data.whatsapp&&!isValidUKPhone(data.whatsapp) && <div style={{ fontSize:12, color:"#f87171", marginTop:6 }}>⚠ Please enter a valid UK mobile number</div>}
              <div style={{ fontSize:11, color:C.muted, marginTop:5 }}>Required — even if the same as your phone number above</div>
            </div>
            <div style={{ marginTop:16 }}><Label>Email address</Label><input type="email" value={data.email} onChange={e=>set("email",e.target.value)} placeholder="you@example.com" style={inputStyle} /></div>
            <div style={{ display:"flex", alignItems:"flex-start", gap:10, background:"rgba(22,163,74,0.06)", border:"1px solid rgba(22,163,74,0.2)", borderRadius:12, padding:"13px 15px", fontSize:12, color:"#6dcf8c", lineHeight:1.65, marginTop:18 }}>
              🔒 Your contact details are kept completely private. Only revealed to a bodyshop after they pay for your lead. Fully GDPR compliant.
            </div>
            <button onClick={()=>{
              if(!data.name.trim()){alert("Please enter your full name.");return;}
              if(!isValidUKPhone(data.phone)){alert("Please enter a valid UK mobile number.\n\nExamples:\n• 07700 900000\n• +447700900000");return;}
              if(!data.whatsapp.trim()){alert("Please enter your WhatsApp number. This is required so bodyshops can reach you.");return;}
              if(!isValidUKPhone(data.whatsapp)){alert("Please enter a valid UK WhatsApp number.");return;}
              if(!data.email.includes("@")){alert("Please enter a valid email address.");return;}
              next();
            }} style={redBtn}>Continue →</button>
          </div>
        )}

        {step===7 && (
          <div>
            <h2 style={{ fontSize:26, fontWeight:900, marginBottom:8 }}>When's the best time to reach you?</h2>
            <p style={{ fontSize:14, color:"#999", marginBottom:24, lineHeight:1.6 }}>Bodyshops will call or WhatsApp you to discuss the job and quote.</p>
            <div style={{ display:"flex", flexDirection:"column", gap:10 }}>
              {["Anytime","Morning (8am – 12pm)","Afternoon (12pm – 5pm)","Evening (5pm – 8pm)","Weekends only"].map(v=><OptBtn key={v} field="callTime" value={v} />)}
            </div>
            <div style={{ marginTop:22 }}><Label>Anything else to add? (optional)</Label>
              <textarea value={data.notes} onChange={e=>set("notes",e.target.value)} placeholder="e.g. WhatsApp only, best to text first..." rows={3} style={{ ...inputStyle, resize:"none", lineHeight:1.6 }} />
            </div>
            <button onClick={()=>{
              if(!data.callTime){alert("Please select the best time to reach you.");return;}
              submit();
            }} disabled={uploading} style={{ ...redBtn, background: uploading?"#666":"#16A34A", boxShadow:"0 6px 24px rgba(22,163,74,0.3)" }}>
              {uploading ? "Submitting..." : "🎉 Submit & Get My Free Quotes"}
            </button>
          </div>
        )}
      </div>
    </div>
  );
}

const redBtn = { width:"100%", background:"#E8341A", color:"#fff", border:"none", borderRadius:14, padding:"17px", fontSize:16, fontWeight:800, cursor:"pointer", fontFamily:"inherit", marginTop:24, letterSpacing:"-0.2px" };
const inputStyle = { width:"100%", background:"#0D0D0D", border:`1.5px solid #252525`, borderRadius:12, padding:"13px 16px", color:"#F5F5F5", fontFamily:"inherit", fontSize:14, outline:"none", boxSizing:"border-box" };
